var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircleGreen = function SvgCheckCircleGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#19af00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.25 12.75 11.5 15l3.75-5.25m6 2.25a9 9 0 1 1-18 0 9 9 0 0 1 18 0"
  })));
};
export { SvgCheckCircleGreen as ReactComponent };
export default __webpack_public_path__ + "f3a2fe3b4679e66b4b38589b28447434.svg";